export const SESSION_TOKEN = 'session_token'